import React, { forwardRef } from 'react';
import { TextFieldProps } from '@mui/material';
import { CurrencyObject } from 'common/types';
import MoneyTextField from 'common/components/MoneyTextField';

interface Props {
	currency: CurrencyObject;
	value?: number;
	onChange?: (value: number) => void;
	TextFieldProps?: TextFieldProps;
}

const PriceTextField = forwardRef(({ currency, value, onChange, TextFieldProps }: Props, ref) => (
	<MoneyTextField
		{...TextFieldProps}
		value={value}
		onValueChange={(value) => onChange?.(value)}
		fullWidth
		currency={currency}
		useMinorUnits
		InputLabelProps={{
			shrink: true,
		}}
	/>
));

export default PriceTextField;
